import { Type } from "class-transformer";
import { UpdateFileMetaData } from "./UpdateFileMetaData";

export class UpdatePackageMetaData {
    id: string;
    @Type(() => UpdateFileMetaData)
    files: UpdateFileMetaData[];
}
